import entityHelper from '../utils/entityHelper'
import RACES from './RACES'

const { createBaseUnit } = entityHelper

const HEROES = {
    XY001: {
        sourceID: 'XY001',
        ...createBaseUnit('good', RACES.HUMAN.ID, 'Hans', 'male', { timeframe: 20 }),
    },
    XY002: {
        sourceID: 'XY002',
        ...createBaseUnit('good', RACES.HUMAN.ID, 'Olga', 'female', { timeframe: 20, stats: { hp: -15, attack: 10, rate: -5 } }),
    },
    XY003: {
        sourceID: 'XY003',
        ...createBaseUnit('good', RACES.ELF.ID, 'Tingle', 'male', { timeframe: 10 }),
    },
    XY004: {
        sourceID: 'XY004',
        ...createBaseUnit('good', RACES.ELF.ID, 'Zelda', 'female', { timeframe: 10 }),
    },
    XY005: {
        sourceID: 'XY005',
        ...createBaseUnit('good', RACES.FAIRY.ID, 'Peter', 'male', { timeframe: 0 }),
    },
    XY006: {
        sourceID: 'XY006',
        ...createBaseUnit('good', RACES.FAIRY.ID, 'Navi', 'female', { timeframe: 0 }),
    },
}

export default HEROES
